jQuery(document).ready(function ($) {

    const $members_form = $('.masthead-members__form');

    ;( function () {

        const $abc_list = $members_form.find('.members-abc__list');
        $abc_list.find('a').on('click', function (e) {
            e.preventDefault();
            const $this = $(this);
            const letter = $this.data('letter');
            const $letter_input = $members_form.find('[name="letter"]');
            $letter_input.val('');
            letter && $letter_input.val(letter);
            $members_form.trigger('submit');
        });

    })();

});